export default {
      id: "write-edit-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "img/icons.svg#write-edit",
      toString: function () {
        return this.url;
      }
    }